<template>
  <div class="drawer-notice">
    <drawer
      :title="'通知信息'"
      v-model="visible"
      :width="'30%'"
      :styles="bodyStyle"
      @on-visible-change="handleDrawerVisibleChange"
      @on-close="handleClose"
      @update-scroller="computeHeight"
    >
      <template slot="more">
        <div class="notice-more">
          <el-dropdown :popper-append-to-body="false" @command="handleCommand">
            <a href="javascript:;" class="btn"><i class="mng icon-more-dots"></i></a>
            <el-dropdown-menu slot="dropdown" class="notice-dropdown">
              <el-dropdown-item class="drop-list" command="makeAllRead">
                <a href="javascript:;" class="drop-link">
                  <span class="drop-icon"><i class="mng icon-double-tick"></i></span>
                  <span class="drop-txt">标记全部为已读</span>
                </a>
              </el-dropdown-item>
              <el-dropdown-item class="drop-list" command="deleteAll">
                <a href="javascript:;" class="drop-link">
                  <span class="drop-icon"><i class="mng icon-lajitong-copy-copy"></i></span>
                  <span class="drop-txt">删除所有已读</span>
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <notice-panel
        :noticeGroups="noticeGroups"
        :noticeList="noticeList"
        :hasMore="hasMore"
        :loadingMore="loadingMore"
        :curTabName="curTabName"
        :scrollHeight="scrollHeight"
        :loading="loading"
        :unreadNum="unreadNum"
        @notice-status-change="handleNoticeStatusChange"
        @load-more="handleLoadMore"
        @load-notice="loadNotice"
      ></notice-panel>
    </drawer>
  </div>
</template>
<script>
  import Drawer from '../drawer/drawer'
  import config from './config'
  import util from '../../libs/util'
  import NoticePanel from './notice-panel'
  import ws from '../../websocket'
  export default {
    name: 'drawer-notice',
    components: {NoticePanel, Drawer},
    props: {
    },
    data() {
      return {
        loading: false,
        loadingMore: false,
        visible: false,
        curTabName: 'all',
        startIndex: 0,
        noticeList: [],
        hasMore: false,
        unreadNum: 0,
        wsChannel: 'serverNotice',
        tipsDeploy: 300,
        bodyStyle: {
          height: 'calc(100% - 56px)'
        },
        scrollHeight: document.documentElement.offsetHeight - 140
      }
    },
    computed: {
      drawerStyle: function () {
        return {
          left: (this.$store.state.app.showLeftMenu ? 251 : 0) + 'px'
        }
      },
      noticeGroups: function () {
        return config.noticeGroups
      }
    },
    created() {
      this.queryUnreadNum()
      // handle `esc` key
      window.addEventListener('keydown', evt => {
        if (evt.keyCode === 27 && this.visible) {
          this.hide()
        }
      })
    },
    mounted() {
      ws.registerObserver(this.wsChannel, this)
    },
    beforeDestroy() {
      ws.removeObserver(this.wsChannel, this)
    },
    methods: {
      computeHeight() { // 计算高度
        this.scrollHeight = document.documentElement.offsetHeight - 140
      },
      show() {
        this.visible = true
      },
      hide() {
        this.visible = false
      },
      toggle() {
        this.visible = !this.visible
      },
      onMessage(data) {
        if (this.curTabName === 'all' || this.curTabName === 'unread') {
          this.noticeList.unshift(data.data)
        }
        this.unreadNum++
        this.$notify({
          title: '消息',
          message: '您有一条新通知！',
          position: 'bottom-left'
        })
      },
      // drawer关闭时触发
      handleClose() {
        this.$emit('close')
      },
      // drawer显示时重新加载数据
      handleDrawerVisibleChange(visible) {
        if (visible) {
          this.loadFirstPage()
        }
      },
      queryUnreadNum() {
        util.ajax.post('/core/serverNotice/queryUnreadNum').then(res => {
          if (res.data.meta.errCode === 0) {
            this.unreadNum = res.data.data
            if (this.unreadNum > 0) {
              this.$notify({
                title: '消息',
                message: '您有 ' + this.unreadNum + ' 条新通知！'
              })
            }
          }
        }).catch(err => {
          console.error(err)
        })
      },
      loadFirstPage() {
        this.startIndex = 0
        this.noticeList = []
        this.loading = true
        this.loadNotice()
      },
      loadNotice(noticeGroup) {
        if (noticeGroup) {
          this.curTabName = noticeGroup.name
        }
        let hasMore = this.hasMore
        this.hasMore = false
        let params = {
          type: this.curTabName,
          startIndex: this.startIndex,
          pageSize: config.pageSize
        }
        let onCurTabName = this.curTabName
        util.ajax.post('/core/serverNotice/notice', {params}).then(res => {
          if (onCurTabName === this.curTabName) { // 如果tab已经切换，则不处理返回结果
            this.loading = false
            this.loadingMore = false
            if (res.data.meta.errCode === 0) {
              this.noticeList = [...this.noticeList, ...res.data.data.noticeList]
              this.hasMore = res.data.data.hasMore
              this.startIndex += config.pageSize
            } else {
              this.$notify.error({title: '错误', message: '加载通知信息失败！' + res.data.meta.errMsg})
            }
          }
        }).catch(err => {
          if (onCurTabName === this.curTabName) { // 如果tab已经切换，则不处理返回结果
            this.loading = false
            this.loadingMore = false
            this.hasMore = hasMore
            console.error(err)
            this.$notify.warning({title: '错误', message: '加载通知信息失败！'})
          }
        })
      },
      handleLoadMore() {
        this.loadingMore = true
        this.loadNotice()
      },
      handleNoticeStatusChange(notice, status) {
        if (status === 'read') {
          this.markNoticeRead(notice)
        } else if (status === 'star') {
          this.markNoticeStar(notice)
        } else if (status === 'unstar') {
          this.markNoticeUnstar(notice)
        } else if (status === 'delete') {
          this.markNoticeDelete(notice)
        }
        let params = {
          noticeId: notice.id,
          status: status
        }
        util.ajax.post('/core/serverNotice/updateNoticeStatus', {params}).then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '修改状态失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '修改状态失败！'})
        })
      },
      markNoticeRead(notice) {
        this.$set(notice, 'read', true)
        this.unreadNum--
        // 如果当前位于未读列表，则将notice从列表中移除
        if (this.curTabName === 'unread') {
          this.removeNoticeFromList(notice)
        }
      },
      markNoticeStar(notice) {
        this.$set(notice, 'star', true)
      },
      markNoticeUnstar(notice) {
        this.$set(notice, 'star', false)
        // 如果当前位于星标列表，则将notice从列表移除
        if (this.curTabName === 'star') {
          this.removeNoticeFromList(notice)
        }
      },
      markNoticeDelete(notice) {
        this.$set(notice, 'delete', false)
        if (!notice.read) {
          this.unreadNum--
        }
        this.removeNoticeFromList(notice)
      },
      removeNoticeFromList(notice) {
        for (let i = 0; i < this.noticeList.length; i++) {
          if (this.noticeList[i].id === notice.id) {
            this.noticeList.splice(i, 1)
            break
          }
        }
      },
      makeAllRead() { // 全部已读
        this.unreadNum = 0
        for (let i = 0; i < this.noticeList.length; i++) {
          this.$set(this.noticeList[i], 'read', true)
        }
        // 更新数据库
        util.ajax.post('/core/serverNotice/updateAllRead').then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '操作失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '操作失败！'})
        })
        this.$nextTick(this.loadNotice())
      },
      deleteAll() { // 删除全部
        this.unreadNum = 0
        this.noticeList = []
        // 更新数据库
        util.ajax.post('/core/serverNotice/deleteAll').then(res => {
          if (res.data.meta.errCode === 0) {
          } else {
            this.$notify.error({title: '错误', message: '操作失败！' + res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.warning({title: '错误', message: '操作失败！'})
        })
      },
      handleCommand(command) {
        if (command === 'deleteAll') {
          this.deleteAll()
        } else if (command === 'makeAllRead') {
          this.makeAllRead()
        }
      }
    },
    watch: {
      'curTabName': function () {
        this.loadFirstPage()
      },
      'unreadNum': function (newValue) {
        this.$emit('unread-notice-num-change', newValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/drawer-notice/drawer-notice.vue